export default __webpack_public_path__ + "a08bcb9b440a99ccfede8d2c1edb9cc0.png";